import "./DynamicPricingForecastingServices2.module.css";
import Header from "@/reusable_sections/Header";
import Dynamicpricinghero from "./sections/Dynamicpricinghero";
import Methodology from "./sections/Methodology";
import Pricing from "./sections/Pricing";
import Adaptivepricinglogic from "./sections/Adaptivepricinglogic";
import Technology from "./sections/Technology";
import Performance from "./sections/Performance";
import Pricingandforecastingfaq from "./sections/Pricingandforecastingfaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function DynamicPricingForecastingServices2Page() {
  return <div>
      <Header />
      <Dynamicpricinghero />
      <Methodology />
      <Pricing />
      <Adaptivepricinglogic />
      <Technology />
      <Performance />
      <Pricingandforecastingfaq />
      <Services />
      <Footer />
    </div>;
}